import * as types from 'constants/actionTypes';
import initialState from './initialState';

export default function clientSummariesReducer(
  state = initialState.referenceData.clientSummaries,
  action
) {
  if (action.type === types.GET_CLIENT_SUMMARIES_SUCCESS) {
    return action.clientSummaries;
  }
  return state;
}
